import { z } from 'zod';

export const departmentSchema = z.object({
  name: z.string()
    .min(2, 'Department name must be at least 2 characters')
    .max(100, 'Department name must not exceed 100 characters')
    .refine(name => /^[a-zA-Z0-9\s-]+$/.test(name), {
      message: 'Department name can only contain letters, numbers, spaces and hyphens'
    }),
  description: z.string()
    .max(500, 'Description must not exceed 500 characters')
    .nullable()
    .optional(),
  status: z.enum(['active', 'inactive', 'archived'])
    .default('active'),
  manager_id: z.string()
    .nullable()
    .optional()
    .or(z.literal('none'))
});

export type DepartmentFormData = z.infer<typeof departmentSchema>;